import React from 'react'

const ClampOntester = () => {
  return (
    <div>
       <section class="inner-banner">
        <div class="thm-container">
          <h2> Product Details </h2>
          <div class="breadcumb">
            <a href="/">Yokogawa</a>
            <i class="fa fa-angle-right"></i>
            <span>Handheld Instruments </span>
            <i class="fa fa-angle-right"></i>
            <span>Clamp-on Testers</span>
          </div>
        </div>
      </section> 
      <div className='container py-4'>
        <div className='row d-flex' style={{ margin: "80px 0px" }}>
          <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
            <img src='/img/clampon.png' width={400} ></img>
          </div>
          <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
            <h2 style={{ textDecoration: "underline" }}>Clamp-on Testers:</h2>
            <p className="mbot25">
             <ul>
              <li>16 models of clamp-on testers</li>
              <li>CL Series- AC, AC/DC, leakage current clamps, mini clamp meters</li>
              <li>RMS, Mean, Temperature, frequency, and recorder output clamp testers</li>
             </ul>
            </p>
          </div>
        </div>
      
      </div>
    </div>
  )
}

export default ClampOntester
